define(function (require) {
    "use strict";
    var AppConfig = require('config/application');
    var Marionette = require('marionette');

    var Handlebars = require('handlebars');

    var template = require('text!./templates/main.tpl').default;
    var Form = require('./form');

    return Marionette.LayoutView.extend({
        template: template,
        className: 'lpt-intercom',

        ui: {
            btnHideForm: '.js-close-form',
            headerText: '.js-header-text',

            formWrapper: '.js-form-wrapper'
        },
        events: {
            'click @ui.btnHideForm': 'closeForm'
        },
        regions: {
            regionForm: '.js-region-form'
        },
        childEvents: {
            'submitForm': 'onSubmit'
        },
        start: function() {
            var body = $('body');
            this.render();
        },
        end: function() {
            this.destroy();
        },
        onRender: function () {
            var _self = this;
            this.checkUseIntercomWrapper = false;
            this.getWidgetOptions(function (categoryArray, headerString) {
                if(categoryArray.length) {
                    _self.categoryArray = categoryArray;
                    _self.setHeader(headerString);

                    var newPartnerFlag = app.Models.Account.get('new_partner');
                    var f = new Form(categoryArray);
                    f.setPartnerFlag(newPartnerFlag);

                    _self.getRegion('regionForm').show(f);

                    $('body').append(_self.$el);
                    _self.checkUseIntercomWrapper = true;
                }
            });
        },
        onSubmit: function (view, data) {
            this.requestSend(data);
        },
        setHeader: function (header) {
            this.ui.headerText.html(header);
        },

        showCloseFormBtn: function() {
            $(this.ui.btnHideForm).show();
        },
        hideCloseFormBtn: function() {
            $(this.ui.btnHideForm).hide();
        },

        showForm: function() {
            this.showCloseFormBtn();
            this.showMainWindow();
        },

        closeForm: function() {
            this.hideCloseFormBtn();

            this.hideMainWindow();
        },
        showMessageSuccess: function () {
            return window.app.message.success('Сообщение отправлено, пожалуйста подождите');
        },
        showMessageError: function (message) {
            message = message || 'Произошла ошибка при отправке, сообщите нам по телефону';
            return window.app.message.error(message);
        },
        resetForm: function () {
            this.getRegion('regionForm').currentView.render();
        },
        requestSend: function (data) {
            var _self = this;
            var url = AppConfig.host + '/rest/support/intercom_conversation';
            _self.closeForm();
            _self.resetForm();

            Backbone.ajax({
                type: 'POST',
                url: url,
                dataType: 'JSON',
                data: JSON.stringify(data),
                success: function(response, text, data){
                    _self.showMessageSuccess();
                },
                error: function(xhr) {
                    var data = xhr.responseJSON;
                    message.cancel();
                    _self.showMessageError(data.message);
                }
            });
        },
        showMainWindow: function() {
            $(this.ui.formWrapper).show();
        },
        hideMainWindow: function() {
            $(this.ui.formWrapper).hide();
        },

        getWidgetOptions: function (callback) {
            var _self = this;
            var url = AppConfig.host +  '/rest/support/conversation_widget_options';

            Backbone.ajax({
                type: 'GET',
                url: url,
                success: function(response, text, data){
                    var categoryArray = response.result.data.cats;
                    var headerString = response.result.data.header_text;

                    callback(categoryArray, headerString);
                },
                error: function(xhr) {
                    var data = xhr.responseJSON;
                    message.cancel();
                    _self.showMessageError(data.message);
                }
            });
        }
    })
});